// import request from "@/request";
// const baseUrl = 'http://152.136.145.27:8088';
const baseUrl = 'https://www.ortho-k.com.cn/prod-api';
// const baseUrl = 'http://192.168.1.4:8001';
// const baseUrl = "http://itapi.sdnmkj.cn/prod-api";
// const baseUrl = 'http://lxbcb.cn/api';
// const imgUrl = 'https://ortho-k.com.cn/prod-api';
 const imgUrl = 'https://www.ortho-k.com.cn';
//const imgUrl = 'http://192.168.0.103:81/dev-api';
// import Axios from 'axios'
// import fileDownload from "js-file-download";
import { Message } from 'element-ui'

var utils = {
	Url: baseUrl,
	imgUrl: imgUrl,
	pageSize: [10, 20],
	// 下载文件-fileUrl:文件地址，fileName：文件名
	downloadFile(fileUrl, fileName){
		Axios({
			method: 'get',
			url: fileUrl,
			responseType: 'blob'
		}).then(res => {
			fileDownload(res.data, fileName == '' ? '' : fileName);
		});
	},
	getParamsIsEmpty(array){
		console.log(array)
		if(!this.objecAtrtIsEmpty(array)){
			Message({
				message: "提交内容存在空值!",
				type: "error",
				duration: 2000
			});
			return false;
		}else{
			return true;
		}
	},
	// 判断提交的对象是否含有空值
	objecAtrtIsEmpty(data) {
		// 如果是数组，遍历数组里面的
		if (Array.isArray(data)) {
		  if (data.length == 0) return false;
		  return data.every(el => {
			return objecAtrtIsEmpty(el);
		  });
		  // 非空数组
		} else if (Object.prototype.toString.call(data) === "[object Object]" && JSON.stringify(data) !== '{}') {

		  //对象or对象数组
		  return Object.keys(data).every(key => {
			// 如果对象子元素为数组
			if (Array.isArray(data[key])) {
			  if (data[key].length == 0) return false;
			  return data[key].every(el => {
				return objecAtrtIsEmpty(el);
			  });
			} else if (Object.prototype.toString.call(data) === "[object Object]") {
				 // 如果0表示不为空的话可以直接用!data
			  // 直接用!data,非运算符的话有些值为0的话会被过滤掉
			  return data[key] != "" && data[key] != null && data[key] != undefined;
			} else {
			  return key != "" && key != null && key != undefined;
			}
		  });
		} else if (Object.prototype.toString.call(data) === "[object Object]" && JSON.stringify(data) === '{}') {
		  return false;
		} else {
		  // 处理单个值
		  return data != "" && data != null && data != undefined;
		}
	},

	// 时间字符串去除时间
	datetimeOutTime(str){
		if(str == null || str == undefined || str == ''){
			return '';
		}else{
			return str.split(' ')[0];
		}
	},
	// 数组去重
	distinct(arr) {
		var ret = [];
		for (var i = 0; i < arr.length; i++) {
			for (var j = i+1; j < arr.length;) {
				if (arr[i] === arr[j]) {
					ret.push(arr.splice(j, 1)[0]);
				} else {
					j++;
				}
			}
		}
		return ret;
	},

	// 获取当前日期YYYY-MM-DD HH:MM:SS
	getDate(date) {
		let yy = new Date().getFullYear();
		let mm = new Date().getMonth() + 1 < 10 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1;
		let dd = new Date().getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate();
		let hh = new Date().getHours() < 10 ? "0" + new Date().getHours() : new Date().getHours();
		let mf = new Date().getMinutes() < 10 ? "0" + new Date().getMinutes() : new Date().getMinutes();
		let ss = new Date().getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds();

		if (date == "dateNohms0") {
			let dateTime = yy + "-" + mm + "-" + dd + " " + "00:00:00";
			return dateTime;
		} else if (date == "date") {
			let dateTime = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
			return dateTime;
		} else if (date == "dateNohms0By7") {
			let oneDay = 24 * 60 * 60 * 1000;
			let startTime = new Date(Date.now() - 7 * oneDay);
			startTime = this.formatterDate(startTime, "yyyy-MM-dd hh:mm:ss");
			return startTime;
		}
	},

	//时间格式化
	formatterDate(date, fmt) {
		let nowDate = {
			yyyy: date.getFullYear(), // 年
			MM: date.getMonth() + 1, // 月份
			dd: date.getDate(), //日
			hh: date.getHours(),
			mm: date.getMinutes(),
			ss: date.getSeconds()
		};
		if (/(y+)/.test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
		}
		for (var k in nowDate) {
			if (new RegExp("(" + k + ")").test(fmt)) {
				fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? nowDate[k] : ("00" + nowDate[k]).substr(("" + nowDate[k]).length));
			}
		}
		return fmt;
	},
	// 参数处理
	tansParams(params) {
		let result = ''
		for (const propName of Object.keys(params)) {
			const value = params[propName];
			var part = encodeURIComponent(propName) + "=";
			if (value !== null && value !== "" && typeof (value) !== "undefined") {
				if (typeof value === 'object') {
					for (const key of Object.keys(value)) {
						if (value[key] !== null && value[key] !== "" && typeof (value[key]) !== 'undefined') {
							let params = propName + '[' + key + ']';
							var subPart = encodeURIComponent(params) + "=";
							result += subPart + encodeURIComponent(value[key]) + "&";
						}
					}
				} else {
					result += part + encodeURIComponent(value) + "&";
				}
			}
		}
		return result
	},
	// 验证是否为blob格式
	async blobValidate(data) {
		try {
			const text = await data.text();
			JSON.parse(text);
			return false;
		} catch (error) {
			return true;
		}
	},
	// 数字字符串转数字保留两位小数
	stringToNumSave2(str){
		return Number(str).toFixed(2);
	},
	// 去除html标签
	removeHTMLTag(str) {
		if(str){
			str = str.replace(/<\/?[^>]*>/g, ''); // 去除HTML tag
			str = str.replace(/[ | ]*\n/g, '\n'); // 去除行尾空白
			str = str.replace(/\n[\s| | ]*\r/g,'\n'); //去除多余空行
			str = str.replace(/ /ig, ''); // 去掉
			const arrEntities = { 'lt': '<', 'gt': '>', 'nbsp': ' ', 'amp': '&', 'quot': '"' }; // 转义符换成普通字符
			str = str.replace(/&(lt|gt|nbsp|amp|quot);/ig, function(all, t) { return arrEntities[t] });
			return str;
		}else return '';
	},
	// 判断参数是否为空
	isParamsEmpty(params, tips){
		if(params == ''){
			Message({
				message: tips,
				type: "error",
			});
			return false;
		}else{
			return true;
		}
	},
	// 判断值是否为空
	isShowEmpty(value, returnValue){
		if(value === null || value === undefined || value === ''){
			if(returnValue == ''){
				return '';
			}else{
				return returnValue;
			}
		}else{
			return value;
		}
	},
	toPage(path) {
		this.$router.push(path);
	},
	// 显示提示
	showToast(txt, type){
		Message({
			message: txt,
			type: type,
		});
	},
	// 判断页码
	getPageSize(pageNum, pageSize, total){
		var maxPage = total%pageSize== 0?total/pageSize:Math.ceil(total/pageSize)
		if(pageNum < maxPage){
			return true;
		}else{
			return false;
		}
	},
};
export default utils;



// WEBPACK FOOTER //
// ./src/utils/utils.js